exports.baseURL = "https://admin.allme2fun.com/";
exports.key = "V4D6sc5aaW";
exports.projectName = "Allme2fun"
